import {isValidState, isValidZip, isValidPhoneNumber, phoneNumberTyping, isValidEmailAddress } from "../../supplementary_components/supplementaryMethods"
import { API_ROOT } from '../../supplementary_components/requests';
import {
    WEEKLY_GROSS_RESET_WEEK_START,
    parseWeeklyGrossResetHourLabel,
    weeklyGrossResetHourDataset,
} from "./weeklyGrossResetHour";

export const COMPANY_ADD_CONF = {
    formAccessLevel: { key: 'COMPANY_ADMIN' },
    formTitle: "Add Company",
    name: 'addCompanyForm',
    addLink: API_ROOT+'companies/add',
    successMessage:'Company was added',
    columns: [
        {
            label: "Company Name",
            name: "companyName",
            mandatory: true,
        },
        {
            label: "MC Number",
            name: "mcNumber",
            mandatory: true,
        },
        {
            label: "DOT Number",
            name: "dotNumber",
            filters:[
                (val)=>{
                    return val.replace(/[^0-9]/g,"");
                }
            ],
            
            mandatory: true,
        },
        {
            label: "Address Line 1",
            name: "addressLine1",
            mandatory: true,
        },
        {
            label: "Address Line 2",
            name: "addressLine2",
            autoComplete:"off"
        },
        {
            label: "City",
            name: "city",
            mandatory: true,
        },
        {
            label: "State",
            name: "state",
            mandatory: true,
            onblur:(val)=>{
                const newVal = isValidState(val);
                return newVal ? newVal : ''
            }
        },
        {
            label: "Postal Code",
            name: "postalCode",
            mandatory: true,
            onblur:(val)=>{
                const newVal = isValidZip(val);
                return newVal ? newVal : '';
            }
        },
        {
            label: "Phone Number",
            name: "phoneNumber",
            mandatory: true,
            autoComplete:'off',
            filters:[
                phoneNumberTyping
            ],
            onblur:(val, tar)=>{
                return isValidPhoneNumber(val, tar);
            }
            
        },
        {
            label: "Email Address",
            name: "email",
            mandatory: true,
            autoComplete:'off',
            onblur:(val, target)=>{
                return isValidEmailAddress(val, target);
            }
        },
        {
            label: "Preferred Default Timezone",
            name: "defaultTimezone",
            type: "select",
            dataset: ["Eastern", "Central", "Mountain", "Pacific"],
            processBeforeSending : (val)=>{
                switch (val) {
                    case "Eastern":
                        return "America/New_York";
                    case "Central":
                        return "America/Chicago";
                    case "Mountain":
                        return "America/Denver";
                    case "Pacific":
                        return "America/Los_Angeles";
                    default:
                        return "America/Chicago";
                }
            }
        },
        {
            label: "Week Starts From",
            name: "firstDayOfAWeek",
            type: "select",
            dataset: ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"],
        },
        {
            label: "Last Invoice Number",
            name: "lastInvoiceNumber",
            onblur:(val)=>{
                return val.replace(/[^0-9]/g,"");
            },
            mandatory: true,
            
        },
        {
            label: "HOS Calculation/Warnings",
            name: "hosCalculation",
            type: "select",
            dataset: ["False", "True"],
            processBeforeSending : (val)=>{
                return val === "False" ? false : true;
            }
        },
        {
            label: "Owner/Lease Statement Period",
            name: "ownerLeasePayoutFollowsWeeklyRateDistribution",
            type: "select",
            dataset: ["Weekly Rate Allocation", "Delivery Date"],
            processBeforeSending : (val)=>{
                return val === "Weekly Rate Allocation";
            },
            defaultValue: () => "Weekly Rate Allocation",
        },
        {
            label: "Weekly Gross Reset Time",
            name: "weeklyGrossResetHour",
            type: "select",
            dataset: weeklyGrossResetHourDataset(),
            processBeforeSending: (val) => parseWeeklyGrossResetHourLabel(val),
            defaultValue: () => WEEKLY_GROSS_RESET_WEEK_START,
        },
    ]
}